
import Vue from "vue";
import { LOYALTY } from "@/store/loyalty";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";

export default Vue.extend({
  methods: {
    onCustomerSelected(customer: any) {
      this.$router.push({
        name: LOYALTY_ROUTE_NAMES.CUSTOMER_DETAILS,
        params: { id: customer.accountNumber }
      });
    }
  }
});
